
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/crm",
      function () {
        return require("private-next-pages/features/crm.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/crm"])
      });
    }
  